import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './services/authentication.service';
import { JwtPayload } from './services/jwt.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { LinkCardComponent } from './cards/cards-partner/link-card/link-card.component';
import { CardService } from './services/card.service';

interface UserCard {
  code: string;
  status: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'SF-APP';
  user: JwtPayload | null = null;
  isPublicRoute = false;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private cardService: CardService
  ) {
    this.authService.currentUser$.subscribe((user) => {
      this.user = user;
    });
  }

  ngOnInit(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      const url = this.router.url;
      this.isPublicRoute = url.startsWith('/links');
      const redirectedMatch = url.match(/^\/cards\/link\?code=([A-Za-z0-9_]+)&id=([A-Za-z0-9_]+)$/);
      if (redirectedMatch) {
        const code = redirectedMatch[1];
        const id = redirectedMatch[2];
        this.openLinkCardDialog(code, id);
      }
    });
  }

  openLinkCardDialog(code: string, id: string): void {
    if (!code) {
      return;
    }

    this.cardService.getCardsUser(code).subscribe({
      next: (res) => {
        const cards: UserCard[] = res.body?.data?.content || [];
        const card = cards.find((c) => c.code === code);
        if (!card || card.status === 'FABRICATED') {
          this.openDialog(code, id);
          return;
        }
      },
      error: (err) => {},
    });
  }

  private openDialog(code: string, id: string): void {
    this.dialog.open(LinkCardComponent, {
      data: { code, id },
      minWidth: '330px',
      disableClose: true,
    });
  }

  sendEmail() {
    const email = 'kkbayer@sodalite.agency';
    const subject = "Problème rencontré ou demande d'informations complémentaires";
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
  }
}
